import React from 'react';
import { TextField } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  inputBase: {
    fontSize: 'inherit'
  },
  input: {
    height: '15px'
  },
  inputLabel: {
    transform: 'translate(14px, 14px) scale(1)',
    '&.MuiInputLabel-shrink': {
      transform: 'translate(14px, -8px) scale(0.75)'
    }
  }
});

const LoginTextField = props => {
  const { InputProps, inputProps, InputLabelProps, ...rest } = props;

  const { classes } = useStyles();

  return (
    <TextField
      className="input"
      variant="outlined"
      slotProps={{
        input: {
          classes: {
            root: classes.inputBase,
            input: classes.input
          },
          ...InputProps
        },
        htmlInput: inputProps,
        inputLabel: { className: classes.inputLabel, ...InputLabelProps }
      }}
      {...rest}
    />
  );
};

export default LoginTextField;
